var $ = require('jquery');
var maintenanceMode = require('diy/maintenanceMode/maintenanceMode');
var domainpromo = require('diy/domainpromo/domainpromo');
var l10n = require('diy/util/l10n');
var features = require('diy/util/features');

var Widget;

/**
 * Class rendering the publish button or on/off switch for the maintenance mode
 * Not a jQuery UI widget because we can't define it without polluting the
 * jquery.fn namespace
 */
Widget = Klazz.extend({
    options: {
        baseCls: 'diy-maintenance-widget'
    },

    /**
     * @param JQuery element
     */
    initialize: function(element) {
        this.element = element;

        this._create();
        this._init();
    },

    _create: function() {
        this.element.append(this.getHtml());
        this.element.addClass(this.options.baseCls);
    },

    _init: function() {
        this.element
            .find('.' + this.options.baseCls + '-switch')
            .diy_switch({
                showLabels: true,
                labels: {
                    unchecked: l10n.getString('toolbar.maintenance.switch.offline.label'),
                    checked: l10n.getString('toolbar.maintenance.switch.online.label')
                },
                change: this.toggle.bind(this)
            });

        this.refresh();
    },

    getHtml: function() {
        return '<div class="' + this.options.baseCls + '-switch"></div>';
    },

    refresh: function() {
        this.updateState();
    },

    updateState: function() {
        var state = maintenanceMode.getState();
        this._setState(state);
    },

    _setState: function(state) {
        this.element
            .find('.' + this.options.baseCls + '-switch')
            .diy_switch('option', 'checked', !state);
    },

    toggle: function(active) {
        maintenanceMode
            .toggleState(active)
            .done();
    }
});

module.exports = Widget;



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/maintenanceMode/MaintenanceModeWidget.js
 ** module id = 720
 ** module chunks = 0
 **/